import { i18n } from "./i18n";
import en from "./messenger/en.json";

i18n.addResourceBundle("en", "translations", { messenger: en }, true, true);

// The installation currently uses Portuguese; other locales use the source copy.
const pt = {
  conversations: "Conversas", tools: "Todas as ferramentas", actions: "Ações do atendimento",
  back: "Voltar às conversas", close: "Fechar", more: "Mais", newConversation: "Nova conversa",
  filters: "Filtros", theme: "Alterar tema", options: "Opções da mensagem", message: "Mensagem",
  labels: "Etiquetas", welcome: "Suas conversas, em um só lugar",
  welcomeHint: "Selecione uma conversa para começar a responder.", accept: "Aceitar atendimento", all: "Todos",
  internal: "Chat interno", agenda: "Agenda", broadcast: "Disparador & Áudios", attachment: "Anexar arquivo",
  assigned: "Em atendimento", mute: "Silenciar microfone", unmute: "Ativar microfone", leaveRoom: "Sair da sala",
};

export const messengerText = key => i18n.t(`messenger.${key}`, {
  defaultValue: i18n.language.startsWith("pt") ? pt[key] : en[key],
});
